<template>
  <div
    class="row"
  >
    <v-select
      v-model="value.criteriaId"
      :disabled="readonly"
      :items="criteraSelectOption"
      class="col-4"
      item-text="title"
      item-value="id"
      :menu-props="{ transition: false }"
      @change="updateStructureType()"
    />
    <v-select
      v-model="value.operator"
      :disabled="readonly"
      :items="operatorSelectOption"
      class="col-2"
      item-text="displayName"
      item-value="value"
      :menu-props="{ transition: false }"
      @change="setOperator()"
    />
    <v-select
      v-if="
        filterType == 1 ||
          filterType == 4 ||
          filterType == 9 ||
          filterType == 10 ||
          filterType == 11
      "
      v-model="value.criteriaListEntryId"
      :disabled="readonly"
      :item-text="
        (item) => {
          return item.contents.length == 0
            ? item.code
            : getContentsInOrder(item.contents);
        }
      "
      :items="valueItems"
      class="col-5"
      item-value="id"
      @change="setValue()"
    />
    <div
      v-else-if="filterType === 6 || filterType === 7 || filterType === 8"
      class="col-6"
    >
      <v-autocomplete
        :value="selectedPlzPaths"
        :items="plzAutoCompleteOptions"
        :multiple="!isMultiSelectForbidden"
        :allow-overflow="false"
        clearable
        :menu-props="{ transition: false }"
      >
        <template v-slot:item="{ item }">
          <div
            class="w-100"
            @click.stop="togglePlzNode(item)"
          >
            <i
              :class="getIcon(item)"
              :style="{ color: getColor(item) }"
            />
            {{ item.text }}
          </div>
        </template>
      </v-autocomplete>
      <u-tree-view
        :disabled="false"
        :selectable="false"
        :tree-view-items="valueItems"
        :value="selectedPlz"
        class="mt-3 w-100"
        item-key="value"
        item-text="text"
      >
        <template v-slot:prepend="{ item }">
          <div @click="togglePlzNode(item)">
            <i
              :class="getIcon(item)"
              :style="{ scale: '1.8', color: getColor(item) }"
            />
          </div>
        </template>
      </u-tree-view>
    </div>
    <v-select
      v-else-if="filterType === 12"
      v-model="value.value"
      :disabled="readonly"
      :items="valueItems"
      return-object
      class="col-6"
      item-text="code"
      item-value="code"
      @change="setValue"
    />
    <v-select
      v-else
      v-model="value.value"
      :disabled="readonly"
      :items="valueItems"
      class="col-6"
      item-text="code"
      item-value="code"
      @change="setValue()"
    />
  </div>
</template>

<script>
import { GetCriteriaCalculatedRange } from "@/services/minimum.wage.services/criteria.minimum.wages.js";
import UTreeView from "@/components/common/UTreeView.vue";
import {
  GetFlatTreeView,
  CreateMiloTreeView,
  CreatedCountryMiloTreeView,
  RestrictLocationTreeViewToCantons,
  RestrictLocationTreeViewToDistricts,
} from "@/helpers/TreeViewHelper.js";
import { BuildTreeFromPlzPaths } from "@/helpers/PlzHelper.js";

export default {
  components: {
    UTreeView,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    groupValueItemIndex: {
      type: Number,
      default: 0,
    },
    limitTreeSelectionByOperator: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentStructureType: 1,
      valueItems: [],
      filterType: 1,
      selectedPlz: [],
      fullTree: [],
      styleTree: {},
      operatorsByType: {
        1: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
        4: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
        2: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
          { value: 2, name: "LessThanOrEqual", displayName: "<=" },
          { value: 3, name: "GreaterThanOrEqual", displayName: ">=" },
        ],
        3: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
          { value: 2, name: "LessThanOrEqual", displayName: "<=" },
          { value: 3, name: "GreaterThanOrEqual", displayName: ">=" },
        ],
        6: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
        7: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
        8: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
        9: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
        10: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
        11: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
        12: [
          { value: 1, name: "Equals", displayName: "=" },
          { value: 4, name: "NotEquals", displayName: "!=" },
        ],
      },
    };
  },
  computed: {
    criteraSelectOption: function () {
      return this.$store.state.mindestLohnKonfiguration.Criteria;
    },
    operatorSelectOption: function () {
      return this.operatorsByType[this.filterType];
    },
    plzAutoCompleteOptions: function () {
      if (
        this.valueItems &&
        this.valueItems[0].children &&
        this.valueItems[0].children.length > 0
      ) {
        if (this.isMultiSelectForbidden) {
          let flatTree = GetFlatTreeView(this.valueItems[0].children);
          let lowesetLevel = flatTree
            .map((x) => x.value.split("/").length)
            .reduce((a, b) => (a > b ? a : b));
          return flatTree.filter(
            (x) => x.value.split("/").length === lowesetLevel,
          );
        }
        return GetFlatTreeView(this.valueItems[0].children);
      }
      return [];
    },
    isMultiSelectForbidden() {
      let result =
        "operator" in this.value &&
        this.value.operator &&
        this.value.operator === 1 &&
        this.limitTreeSelectionByOperator;
      return result;
    },
    selectedPlzPaths() {
      return this.isMultiSelectForbidden ? this.selectedPlz[0] : [];
    },
  },
  created() {
    this.updateStructureType();
    if (this.value.value) {
      this.selectedPlz = [...this.value.value.split(";")];
    }
    this.buildStyleTree();
  },
  methods: {
    togglePlzNode(node) {
      this.styleTree = {};
      if (this.isMultiSelectForbidden) {
        //Logic if the Operator is '='
        //If the Operator is = , only one item can be selected
        if (node.children && node.children.length > 0) {
          return;
        }
        this.setValue([]);
        this.setValue([node.value]);
      } else {
        if (node.children) {
          let currentlySelectedChildren = this.selectedPlz.filter((x) =>
            x.includes(node.value),
          );
          let allChildren = [
            this.valueItems[0],
            ...GetFlatTreeView(this.valueItems[0].children),
          ].filter(
            (x) => x.value.includes(node.value) && x.value != node.value,
          );

          let lowesetLevel = allChildren
            .map((x) => x.value.split("/").length)
            .reduce((a, b) => (a > b ? a : b));
          let allLowestChildren = allChildren.filter(
            (x) => x.value.split("/").length == lowesetLevel,
          );

          if (currentlySelectedChildren.length == allLowestChildren.length) {
            this.setValue(
              this.selectedPlz.filter((x) => !x.includes(node.value)),
            );
          } else {
            this.setValue([
              ...this.selectedPlz.filter((x) => !x.includes(node.value)),
              ...allChildren.map((x) => x.value),
              node.value,
            ]);
          }
        } else {
          if (this.selectedPlz.includes(node.value)) {
            this.setValue(this.selectedPlz.filter((x) => x != node.value));
          } else {
            this.setValue([...this.selectedPlz, node.value]);
          }
        }
      }
    },
    getColor(node) {
      if (node && node.value) {
        let pathPieces = node.value.split("/");
        let canton = pathPieces[1];
        let district = pathPieces[2];
        let plz = pathPieces[3];

        let colorOfNode;
        if (plz) {
          colorOfNode = this.styleTree?.[canton]?.[district]?.[plz]?.color;
        } else if (district) {
          colorOfNode = this.styleTree?.[canton]?.[district]?.color;
        } else if (canton) {
          colorOfNode = this.styleTree?.[canton]?.color;
        } else {
          colorOfNode = this.styleTree?.color;
        }

        if (!colorOfNode) {
          colorOfNode = "grey";
        }
        return colorOfNode;
      }
    },
    getIcon(node) {
      if (node && node.value) {
        let pathPieces = node.value.split("/");
        let canton = pathPieces[1];
        let district = pathPieces[2];
        let plz = pathPieces[3];

        let iconOfNode;
        if (plz) {
          iconOfNode = this.styleTree?.[canton]?.[district]?.[plz]?.icon;
        } else if (district) {
          iconOfNode = this.styleTree?.[canton]?.[district]?.icon;
        } else if (canton) {
          iconOfNode = this.styleTree?.[canton]?.icon;
        } else {
          iconOfNode = this.styleTree?.icon;
        }

        if (!iconOfNode) {
          iconOfNode = "fas fa-square mr-1 ml-2 mt-1";
        }
        return iconOfNode;
      }
    },
    getContentsInOrder(contents) {
      let german = contents.filter((c) => {
        return c.language === "de-CH";
      });

      if (german[0] && german[0].text) {
        return german[0].text;
      }

      let french = contents.filter((c) => {
        return c.language === "fr-CH";
      });

      if (french[0] && french[0].text) {
        return french[0].text;
      }

      let italian = contents.filter((c) => {
        return c.language === "it-CH";
      });

      if (italian[0] && italian[0].text) {
        return italian[0].text;
      }

      return "";
    },
    setValue(newValue) {
      if (
        this.filterType == 1 ||
        this.filterType == 4 ||
        this.filterType == 9 ||
        this.filterType == 10 ||
        this.filterType == 11
      ) {
        this.$emit("input", {
          ...this.value,
          value: this.valueItems.filter((vItem) => {
            return vItem.id == this.value.criteriaListEntryId;
          })[0].code,
        });
      }

      if (
        this.filterType == 6 ||
        this.filterType == 7 ||
        this.filterType == 8
      ) {
        if (newValue && newValue.length > 0) {
          let sortedVal = newValue.sort((a, b) =>
            a.length < b.length ? 1 : -1,
          );
          let longestVal = sortedVal[0].split("/").length;
          let filteredVal = [];
          sortedVal.map((val) => {
            if (
              val.split("/").length == longestVal ||
              !filteredVal.some((x) => x.includes(val))
            ) {
              filteredVal.push(val);
            }
          });

          let outputVal = filteredVal.join(";");
          if (this.selectedPlz.length != filteredVal.length) {
            this.selectedPlz = filteredVal;
            this.$emit("input", {
              ...this.value,
              value: outputVal,
              criteriaListEntryId: null,
            });
          }
        } else {
          this.selectedPlz = newValue;
          this.$emit("input", {
            ...this.value,
            value: null,
            criteriaListEntryId: null,
          });
        }
      }

      if (newValue && this.filterType == 12) {
        this.$emit("input", {
          ...this.value,
          criteriaListEntryId: newValue.criteriaListEntryId,
          value: newValue.code,
        });
      }

      if (
        this.filterType == 6 ||
        this.filterType == 7 ||
        this.filterType == 8
      ) {
        this.buildStyleTree();
      }

      this.$emit(
        "validate-value",
        this.value,
        this.valueItems,
        this.filterType,
        this.groupValueItemIndex,
      );
    },
    setOperator() {
      this.$emit(
        "validate-value",
        this.value,
        this.valueItems,
        this.filterType,
        this.groupValueItemIndex,
      );
    },
    buildStyleTree() {
      let optionsTree = JSON.parse(JSON.stringify(this.valueItems));
      let selectedTree = BuildTreeFromPlzPaths(this.selectedPlz);

      let completeTree = CreatedCountryMiloTreeView(
        this.$store.state.mindestLohnKonfiguration.Cities,
      );

      if (!optionsTree || !optionsTree[0]) {
        return {
          value: "CH",
          color: "grey",
          icon: "fas fa-square mr-1 ml-2 mt-1",
        };
      }

      let styleTree = this.getPlzStyleObject(
        selectedTree,
        selectedTree,
        optionsTree[0],
        completeTree[0],
      );
      //Iterate through the optionsTree
      for (
        let cantonIndex = 0;
        cantonIndex < optionsTree[0].children.length;
        cantonIndex++
      ) {
        let canton = optionsTree[0].children[cantonIndex];
        let completeCanton = completeTree[0].children.find(
          (x) => x.path == canton.value,
        );
        let cantonPathPieces = canton.value.split("/");

        let selectedCantonNode = selectedTree[cantonPathPieces[1]];

        if (selectedCantonNode) {
          styleTree[cantonPathPieces[1]] = this.getPlzStyleObject(
            selectedCantonNode,
            selectedTree,
            canton,
            completeCanton,
          );

          if (!canton.children) {
            continue;
          }
          for (
            let districtIndex = 0;
            districtIndex < canton.children.length;
            districtIndex++
          ) {
            let district = canton.children[districtIndex];
            let completeDistrict = completeCanton.children.find(
              (x) => x.path == district.value,
            );
            let districtPathPieces = district.value.split("/");
            let selectedDistrictNode =
              selectedTree[`${districtPathPieces[1]}`][
                `${districtPathPieces[2]}`
              ];

            if (selectedDistrictNode) {
              styleTree[districtPathPieces[1]][districtPathPieces[2]] =
                this.getPlzStyleObject(
                  selectedDistrictNode,
                  selectedTree,
                  district,
                  completeDistrict,
                );

              if (!district.children) {
                continue;
              }
              for (
                let plzIndex = 0;
                plzIndex < district.children.length;
                plzIndex++
              ) {
                let plz = district.children[plzIndex];
                let completePlz = completeDistrict.children.find(
                  (x) => x.path == plz.value,
                );
                let plzPathPieces = plz.value.split("/");
                let selectedPlzNode =
                  selectedTree[plzPathPieces[1]][plzPathPieces[2]][
                    plzPathPieces[3]
                  ];

                if (selectedPlzNode) {
                  styleTree[plzPathPieces[1]][plzPathPieces[2]][
                    plzPathPieces[3]
                  ] = this.getPlzStyleObject(
                    selectedPlzNode,
                    selectedTree,
                    plz,
                    completePlz,
                  );
                }
              }
            }
          }
        }
      }

      this.resolveStyleTreeNode(styleTree);

      this.styleTree = styleTree;
    },
    resolveStyleTreeNode(node) {
      let props = Object.keys(node)
        .filter((x) => x != "color" && x != "icon")
        .map((x) => node[x]);
      for (let i = 0; i < props.length; i++) {
        let child = props[i];

        if (
          child.color == "grey" &&
          child.icon == "fas fa-minus-square checkbox-minus mr-1 ml-2 mt-1"
        ) {
          node.color = "grey";
          node.icon = "fas fa-minus-square checkbox-minus mr-1 ml-2 mt-1";
        }
        this.resolveStyleTreeNode(child);
      }
    },
    getPlzStyleObject(node, selectedTree, optionsTree, completeTree) {
      let styleObject = {
        color: "grey",
        icon: "fas fa-square mr-1 ml-2 mt-1",
      };

      let pathPieces = node.path.split("/");
      let selectedNode;
      switch (pathPieces.length) {
        case 4:
          selectedNode =
            selectedTree?.[`${pathPieces[1]}`]?.[`${pathPieces[2]}`]?.[
              `${pathPieces[3]}`
            ];
          break;
        case 3:
          selectedNode =
            selectedTree?.[`${pathPieces[1]}`]?.[`${pathPieces[2]}`];
          break;
        case 2:
          selectedNode = selectedTree?.[`${pathPieces[1]}`];
          break;
        default:
          selectedNode = selectedTree;
          break;
      }

      //operation to compare each node of optionTree to CompleteTree and selectedTree
      if (node.numberOfChildren === 0) {
        styleObject.color = "grey";
        styleObject.icon = "fas fa-square mr-1 ml-2 mt-1";

        if (selectedNode) {
          styleObject.color = "red";
          styleObject.icon = "fas fa-check-square mr-1 ml-2 mt-1";
        }
      } else {
        styleObject.color = "grey";
        styleObject.icon = "fas fa-minus-square checkbox-minus mr-1 ml-2 mt-1";

        if (
          node.numberOfChildren == optionsTree.children.length &&
          node.numberOfChildren == completeTree.children.length
        ) {
          styleObject.color = "red";
          styleObject.icon = "fas fa-check-square mr-1 ml-2 mt-1";
        }
      }

      return styleObject;
    },
    updateStructureType() {
      var criteria = this.$store.state.mindestLohnKonfiguration.Criteria.filter(
        (criteriaItem) => {
          return criteriaItem.id == this.value.criteriaId;
        },
      );

      if (this.fullTree || this.fullTree.length == 0) {
        this.fullTree = GetFlatTreeView(
          CreateMiloTreeView(this.$store.state.mindestLohnKonfiguration.Cities),
        );
      }

      if (criteria.length == 1) {
        this.value.criteriaStructureId = criteria[0].criteriaStructureId;
        this.$emit(
          "validate-value",
          this.value,
          this.valueItems,
          this.filterType,
          this.groupValueItemIndex,
        );

        this.filterType = criteria[0].type;

        let plzOfCriteria = [];
        let citiesOfCriteria = [];
        if (
          this.filterType == 6 ||
          this.filterType == 7 ||
          this.filterType == 8
        ) {
          let completeTree = CreateMiloTreeView(
            this.$store.state.mindestLohnKonfiguration.Cities,
          );
          let filteredCities =
            this.$store.state.mindestLohnKonfiguration.Cities.filter((city) =>
              criteria[0].criteriaPlzs.some((plz) =>
                city.path.includes(plz.path ? plz.path : plz),
              ),
            );
          let filteredTree = CreateMiloTreeView(filteredCities);
          if (this.filterType == 6) {
            filteredTree = RestrictLocationTreeViewToCantons(filteredTree);
            completeTree = RestrictLocationTreeViewToCantons(completeTree);
          }
          if (this.filterType == 7) {
            filteredTree = RestrictLocationTreeViewToDistricts(filteredTree);
            completeTree = RestrictLocationTreeViewToDistricts(completeTree);
          }
          let flatTree = GetFlatTreeView(filteredTree);
          this.fullTree = GetFlatTreeView(completeTree);

          plzOfCriteria = flatTree;
          citiesOfCriteria = filteredCities;
        }

        if (this.filterType == 2 || this.filterType == 3) {
          GetCriteriaCalculatedRange(
            this.contractId,
            this.versionId,
            this.editionId,
            criteria[0].id,
            (response) => {
              this.valueItems = [];
              for (
                let index = parseInt(response.range.from);
                index <= parseInt(response.range.to);
                index++
              ) {
                this.valueItems.push({
                  code: index.toString(),
                  id: null,
                });
              }
            },
            () => {
              this.valueItems = [];
              for (let index = 0; index <= 100; index++) {
                this.valueItems.push({
                  code: index.toString(),
                  id: null,
                });
              }
            },
          );
        } else if (this.filterType === 6) {
          let citiesCopy = JSON.parse(JSON.stringify(citiesOfCriteria));

          let plzStructure = [
            {
              text: "Schweiz",
              value: "CH",
              children: [],
            },
          ];
          this.valueItems = [];
          plzOfCriteria.forEach((plz) => {
            let path = plz.path;
            let cityOfEntry = citiesCopy.find((x) => {
              if (path === `CH/${x.cantonCode}`) {
                return true;
              }
              return false;
            });
            plzStructure[0].children.push({
              text: `${cityOfEntry.canton} (${cityOfEntry.cantonCode})`,
              value: path,
            });
          });
          this.valueItems = plzStructure;
        } else if (this.filterType === 7) {
          let citiesCopy = JSON.parse(JSON.stringify(citiesOfCriteria));

          let plzStructure = [
            {
              text: "Schweiz",
              value: "CH",
              children: [],
            },
          ];
          this.valueItems = [];
          plzOfCriteria.forEach((plz) => {
            let path = plz.path;
            let cityOfEntry = citiesCopy.find((x) => {
              if (path === `CH/${x.cantonCode}/${x.districtCode}`) {
                return true;
              }
              return false;
            });

            let cantonOfEntry;
            if (cityOfEntry) {
              cantonOfEntry = plzStructure[0].children.find((x) =>
                x.value.includes(`CH/${cityOfEntry.cantonCode}`),
              );
            }

            if (!cantonOfEntry) {
              if (cityOfEntry) {
                plzStructure[0].children.push({
                  text: `${cityOfEntry.canton} (${cityOfEntry.cantonCode})`,
                  value: `CH/${cityOfEntry.cantonCode}`,
                  children: [
                    {
                      text: `${cityOfEntry.district} (${
                        cityOfEntry.cantonCode
                      })`,
                      value: path,
                    },
                  ],
                });
              }
            } else {
              if (cityOfEntry) {
                cantonOfEntry.children.push({
                  text: `${cityOfEntry.district} (${cityOfEntry.cantonCode})`,
                  value: path,
                });
              }
            }
          });
          this.valueItems = plzStructure;
        } else if (this.filterType === 8) {
          let citiesCopy = JSON.parse(JSON.stringify(citiesOfCriteria)); //~32 ms
          let citiesMap = new Map(
            citiesCopy.map((city) => [
              `CH/${city.cantonCode}/${city.districtCode}/${city.onrp}`,
              city,
            ]),
          );

          let plzStructure = [
            {
              text: "Schweiz",
              value: "CH",
              children: [],
            },
          ];

          this.valueItems = [];
          plzOfCriteria.forEach((plz) => {
            let path = plz.path;
            let cityOfEntry = citiesMap.get(path);

            let cantonOfEntry;
            let districtOfEntry;
            if (cityOfEntry) {
              cantonOfEntry = plzStructure[0].children.find((x) =>
                x.value.includes(`CH/${cityOfEntry.cantonCode}`),
              );
              if (cantonOfEntry) {
                districtOfEntry = cantonOfEntry.children.find((x) =>
                  x.value.includes(
                    `CH/${cityOfEntry.cantonCode}/${cityOfEntry.districtCode}`,
                  ),
                );
              }
            }

            if (!cantonOfEntry) {
              if (cityOfEntry) {
                plzStructure[0].children.push({
                  text: `${cityOfEntry.canton} (${cityOfEntry.cantonCode})`,
                  value: `CH/${cityOfEntry.cantonCode}`,
                  children: [
                    {
                      text: `${cityOfEntry.district} (${
                        cityOfEntry.cantonCode
                      })`,
                      value: `CH/${cityOfEntry.cantonCode}/${
                        cityOfEntry.districtCode
                      }`,
                      children: [
                        {
                          text: `${cityOfEntry.plz} ${cityOfEntry.city}`,
                          value: path,
                        },
                      ],
                    },
                  ],
                });
              }
            } else {
              if (cityOfEntry) {
                if (!districtOfEntry) {
                  cantonOfEntry.children.push({
                    text: `${cityOfEntry.district} (${cityOfEntry.cantonCode})`,
                    value: `CH/${cityOfEntry.cantonCode}/${
                      cityOfEntry.districtCode
                    }`,
                    children: [
                      {
                        text: `${cityOfEntry.plz} ${cityOfEntry.city}`,
                        value: path,
                      },
                    ],
                  });
                } else {
                  districtOfEntry.children.push({
                    text: `${cityOfEntry.plz} ${cityOfEntry.city}`,
                    value: path,
                  });
                }
              }
            }
          });
          this.valueItems = plzStructure;
        } else if (this.filterType === 12) {
          let valueItems = [];
          criteria[0].criteriaGroupedPlzs.forEach((groupedPlz) => {
            let entryForGroup = {
              code: groupedPlz.listEntry.code,
              id: groupedPlz.id,
              criteriaListEntryId: groupedPlz.listEntry.id,
            };
            valueItems.push(entryForGroup);
          });

          this.valueItems = valueItems;
        } else {
          this.valueItems = criteria[0].listEntries;
        }
      }
    },
  },
};
</script>

<style></style>

<style scoped>
.groupingFilterWrapper {
  display: contents;
}
</style>
